import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const hdr = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});


function useSayfalar() {
  const [tumSayfalar, setTumSayfalar] = useState<any[]>([]);
  const [guncelleniyor, setGuncelleniyor] = useState(false);

  const yukle = async () => {
    try {
      const r = await fetch(`${API}/api/sayfa-route/sayfalar`, { headers: hdr() });
      if (r.ok) setTumSayfalar(await r.json());
    } catch {}
  };

  const listeGuncelle = async () => {
    setGuncelleniyor(true);
    try {
      const r = await fetch('/routes-manifest.json');
      if (!r.ok) throw new Error('routes-manifest.json okunamadı');
      const manifest: { route: string; ad: string }[] = await r.json();
      const res = await fetch(`${API}/api/sayfa-route/sayfalar-guncelle`, {
        method: 'POST',
        headers: hdr(),
        body: JSON.stringify(manifest),
      });
      if (res.ok) await yukle();
    } catch (e) {
      alert('Güncelleme başarısız: ' + e);
    } finally {
      setGuncelleniyor(false);
    }
  };

  useEffect(() => { yukle(); }, []);
  return { tumSayfalar, yukle, listeGuncelle, guncelleniyor };
}

const SEV_RENK: Record<number, string> = { 0: '#1a5276', 1: '#1e8449', 2: '#7d6608' };
const SEV_ETIKET: Record<number, string> = { 0: '1. Bar', 1: '2. Bar', 2: 'Sidebar' };


function seviye(kod: string, ustMap: Record<string, string | null>): number {
  let s = 0, k = kod;
  while (ustMap[k]) { k = ustMap[k]!; s++; if (s > 5) break; }
  return s;
}

// ─── HOOK: menu_agac verisini yükle ─────────────────────────────────────────
function useMenuAgac() {
  const [liste, setListe] = useState<any[]>([]);
  const [yukl,  setYukl]  = useState(true);

  const yukle = async () => {
    setYukl(true);
    const r = await fetch(`${API}/api/menu-agac/liste`, { headers: hdr() });
    if (r.ok) {
      const d = await r.json();
      const map: Record<string, string | null> = {};
      (d.liste || []).forEach((x: any) => { map[x.kod] = x.ust_kod; });
      setListe((d.liste || []).map((x: any) => ({ ...x, _sev: seviye(x.kod, map) })));
    }
    setYukl(false);
  };

  useEffect(() => { yukle(); }, []);
  return { liste, yukl, yukle };
}

// ─── SEKME 1: Menü Bağlantıları ─────────────────────────────────────────────
function MenuBaglantilari({ bildir, isAdmin }: { bildir: (m: string) => void; isAdmin: boolean }) {
  const { liste, yukl, yukle } = useMenuAgac();
  const { tumSayfalar } = useSayfalar();
  const [secili, setSecili] = useState<any>(null);
  const [route,  setRoute]  = useState('');
  const [filtre, setFiltre] = useState('');

  const sec = (item: any) => {
    setSecili(item);
    setRoute(item.route || '');
  };

  const kaydet = async () => {
    if (!secili) return;
    const body = {
      kod: secili.kod, ust_kod: secili.ust_kod || null,
      ad: secili.ad, ikon: secili.ikon || null,
      modul_baglantisi: secili.modul || null,
      route: route || null,
      sira: secili.sira || 0, aktif: secili.aktif ?? 1,
    };
    const r = await fetch(`${API}/api/menu-agac/${secili.id}`, {
      method: 'PUT', headers: hdr(), body: JSON.stringify(body),
    });
    if (r.ok) { bildir('✅ Kaydedildi'); setSecili(null); yukle(); }
    else bildir('❌ Kayıt hatası');
  };

  const bagliSayi = liste.filter(x => x.route).length;

  const hierSort = (kod: string) =>
    kod.split('.').map(p => /^\d+$/.test(p) ? p.padStart(5, '0') : p).join('.');

  const filtrelendi = liste
    .filter(x =>
      !filtre ||
      x.kod.toLowerCase().includes(filtre.toLowerCase()) ||
      x.ad.toLowerCase().includes(filtre.toLowerCase()) ||
      (x.route || '').toLowerCase().includes(filtre.toLowerCase())
    )
    .sort((a, b) => hierSort(a.kod).localeCompare(hierSort(b.kod)));

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 360px', gap: 16 }}>
      {/* SOL: Liste */}
      <div className="card" style={{ padding: 0 }}>
        <div style={{ padding: '10px 14px', borderBottom: '1px solid #eee',
          display: 'flex', alignItems: 'center', gap: 8 }}>
          <input className="form-control" placeholder="Filtrele..." value={filtre}
            onChange={e => setFiltre(e.target.value)}
            style={{ flex: 1, fontSize: 12, padding: '4px 8px', height: 30 }} />
          <button className="btn btn-sm" onClick={yukle}
            style={{ background: '#eee', fontSize: 11 }}>🔄</button>
          <div style={{ fontSize: 11, color: '#888', whiteSpace: 'nowrap' }}>
            <strong>{bagliSayi}</strong>/{liste.length} bağlı
          </div>
        </div>
        <div style={{ fontSize: 11, color: '#7d6608', background: '#fffde7',
          padding: '6px 14px', borderBottom: '1px solid #eee' }}>
          💡 Bir satıra tıklayın, sağ panelden sayfa bağlantısı seçin.
        </div>
        {yukl ? (
          <div style={{ padding: 24, textAlign: 'center', color: '#aaa' }}>Yükleniyor...</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#f0f4f8' }}>
                <th style={{ padding: '7px 12px', textAlign: 'left', fontWeight: 600 }}>Kod</th>
                <th style={{ padding: '7px 12px', textAlign: 'left', fontWeight: 600 }}>Ad</th>
                <th style={{ padding: '7px 12px', textAlign: 'left', fontWeight: 600 }}>Seviye</th>
                <th style={{ padding: '7px 12px', textAlign: 'left', fontWeight: 600 }}>Bağlı Sayfa</th>
              </tr>
            </thead>
            <tbody>
              {filtrelendi.length === 0 && (
                <tr><td colSpan={4} style={{ padding: 20, textAlign: 'center', color: '#aaa' }}>Kayıt yok</td></tr>
              )}
              {filtrelendi.map((item, i) => (
                <tr key={item.id} onClick={() => sec(item)}
                  style={{
                    background: secili?.id === item.id ? '#eaf2fb'
                      : i % 2 === 0 ? '#fff' : '#f9fbfd',
                    cursor: 'pointer', borderBottom: '1px solid #f0f0f0',
                  }}>
                  <td style={{ padding: '6px 12px', fontWeight: 700,
                    color: SEV_RENK[item._sev] || '#333',
                    paddingLeft: 12 + item._sev * 16 }}>{item.kod}</td>
                  <td style={{ padding: '6px 12px' }}>{item.ad}</td>
                  <td style={{ padding: '6px 12px' }}>
                    <span style={{ fontSize: 10, background: '#eee', padding: '2px 6px',
                      borderRadius: 3, color: SEV_RENK[item._sev] || '#555' }}>
                      {SEV_ETIKET[item._sev] || `S${item._sev}`}
                    </span>
                  </td>
                  <td style={{ padding: '6px 12px', fontFamily: 'monospace', fontSize: 11,
                    color: item.route ? '#1a5276' : '#bbb' }}>
                    {item.route || '— bağlı değil'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* SAĞ: Bağlantı paneli */}
      <div className="card">
        {!secili ? (
          <div style={{ textAlign: 'center', color: '#aaa', marginTop: 60 }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>📋</div>
            <div style={{ fontSize: 13 }}>Soldan bir menü öğesi seçin</div>
            <div style={{ fontSize: 11, marginTop: 6 }}>Seçtiğiniz öğeye sayfa bağlantısı atayabilirsiniz</div>
          </div>
        ) : (
          <>
            <h3 style={{ fontSize: 14, marginBottom: 12 }}>Sayfa Bağlantısı</h3>
            <div style={{ fontSize: 11, background: '#f0f4f8', borderRadius: 4,
              padding: '8px 12px', marginBottom: 16 }}>
              <div><strong>Kod:</strong> {secili.kod}</div>
              <div><strong>Ad:</strong> {secili.ad}</div>
              <div><strong>Seviye:</strong> {SEV_ETIKET[secili._sev] || `S${secili._sev}`}</div>
            </div>

            <div className="form-group">
              <label style={{ fontSize: 12 }}>Bağlı Sayfa</label>
              <select className="form-control" value={route}
                onChange={e => setRoute(e.target.value)}>
                <option value="">— Bağlantı yok —</option>
                {tumSayfalar.map(s => (
                  <option key={s.route} value={s.route}>{s.ad}  →  {s.route}</option>
                ))}
              </select>
              {route && (
                <div style={{ fontSize: 11, color: '#1a5276', fontFamily: 'monospace', marginTop: 4 }}>
                  {route}
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              {isAdmin && <button className="btn btn-primary" onClick={kaydet}>💾 Kaydet</button>}
              <button className="btn btn-sm" style={{ background: '#eee' }}
                onClick={() => setSecili(null)}>İptal</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ─── SEKME 2: Sayfa Bağlantı Durumu ─────────────────────────────────────────
function SayfaDurumu() {
  const { liste, yukl, yukle } = useMenuAgac();
  const { tumSayfalar, yukle: yukleS } = useSayfalar();
  const [filtre, setFiltre] = useState<'hepsi' | 'bagli' | 'bagsiz'>('hepsi');

  // route → bağlı menü öğeleri map
  const routeMap: Record<string, any[]> = {};
  liste.forEach(item => {
    if (item.route) {
      if (!routeMap[item.route]) routeMap[item.route] = [];
      routeMap[item.route].push(item);
    }
  });

  const sayfaDurumu = tumSayfalar.map(s => ({
    ...s,
    bagli: !!routeMap[s.route],
    bagliMenu: routeMap[s.route] || [],
  }));

  const filtrelendi = sayfaDurumu.filter(s => {
    if (filtre === 'bagli')  return s.bagli;
    if (filtre === 'bagsiz') return !s.bagli;
    return true;
  });

  const bagliSayi  = sayfaDurumu.filter(s => s.bagli).length;
  const bagsisSayi = sayfaDurumu.filter(s => !s.bagli).length;

  return (
    <div className="card" style={{ padding: 0 }}>
      <div style={{ padding: '12px 16px', borderBottom: '1px solid #eee',
        display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <div style={{ fontSize: 13, fontWeight: 600 }}>Sayfa Bağlantı Durumu</div>
        <div style={{ display: 'flex', gap: 6, marginLeft: 'auto' }}>
          {[
            { key: 'hepsi',  label: `Tümü (${sayfaDurumu.length})`,      bg: '#eee',    color: '#333' },
            { key: 'bagli',  label: `✅ Bağlı (${bagliSayi})`,            bg: '#d5f5e3', color: '#1e8449' },
            { key: 'bagsiz', label: `⚠️ Bağsız (${bagsisSayi})`,          bg: '#fdedec', color: '#c0392b' },
          ].map(f => (
            <button key={f.key} onClick={() => setFiltre(f.key as any)}
              style={{
                fontSize: 11, padding: '4px 10px', borderRadius: 4, border: 'none',
                cursor: 'pointer',
                background: filtre === f.key ? f.bg : '#f5f5f5',
                color: filtre === f.key ? f.color : '#888',
                fontWeight: filtre === f.key ? 700 : 400,
                outline: filtre === f.key ? `2px solid ${f.color}` : 'none',
              }}>
              {f.label}
            </button>
          ))}
          <button className="btn btn-sm" onClick={yukle}
            style={{ background: '#eee', fontSize: 11 }}>🔄</button>
        </div>
      </div>

      {yukl ? (
        <div style={{ padding: 24, textAlign: 'center', color: '#aaa' }}>Yükleniyor...</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: '#f0f4f8' }}>
              <th style={{ padding: '7px 12px', textAlign: 'center', fontWeight: 600, width: 60 }}>Durum</th>
              <th style={{ padding: '7px 12px', textAlign: 'left', fontWeight: 600 }}>Sayfa Adı</th>
              <th style={{ padding: '7px 12px', textAlign: 'left', fontWeight: 600 }}>Route</th>
              <th style={{ padding: '7px 12px', textAlign: 'left', fontWeight: 600 }}>Bağlı Menü Öğeleri</th>
            </tr>
          </thead>
          <tbody>
            {filtrelendi.map((s, i) => (
              <tr key={s.route} style={{
                background: i % 2 === 0 ? '#fff' : '#f9fbfd',
                borderBottom: '1px solid #f0f0f0',
                opacity: s.bagli ? 1 : 0.75,
              }}>
                <td style={{ padding: '7px 12px', textAlign: 'center', fontSize: 16 }}>
                  {s.bagli ? '✅' : '⚠️'}
                </td>
                <td style={{ padding: '7px 12px', fontWeight: 600, color: '#333' }}>{s.ad}</td>
                <td style={{ padding: '7px 12px', fontFamily: 'monospace', fontSize: 11, color: '#1a5276' }}>
                  {s.route}
                </td>
                <td style={{ padding: '7px 12px' }}>
                  {s.bagliMenu.length > 0 ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {s.bagliMenu.map((m: any) => (
                        <span key={m.id} style={{
                          fontSize: 10, background: '#eaf2fb', color: SEV_RENK[m._sev] || '#333',
                          padding: '2px 7px', borderRadius: 10, fontWeight: 600,
                        }}>
                          {m.ikon ? `${m.ikon} ` : ''}{m.kod} – {m.ad}
                          <span style={{ fontSize: 9, color: '#aaa', marginLeft: 3 }}>
                            ({SEV_ETIKET[m._sev]})
                          </span>
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span style={{ color: '#e74c3c', fontSize: 11, fontStyle: 'italic' }}>
                      Henüz menüye bağlanmamış
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// ─── ANA BİLEŞEN ─────────────────────────────────────────────────────────────
export default function SayfaBaglantilari() {
  const _user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = ['super_admin', 'gm_yonetici'].includes(_user?.rol);

  const [sekme,  setSekme]  = useState<'menu' | 'sayfa'>('menu');
  const [mesaj,  setMesaj]  = useState('');
  const { listeGuncelle, guncelleniyor } = useSayfalar();

  const bildir = (msg: string) => {
    setMesaj(msg);
    setTimeout(() => setMesaj(''), 3500);
  };

  const handleGuncelle = async () => {
    await listeGuncelle();
    bildir('✅ Sayfa listesi güncellendi');
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1>🔗 Sayfa Bağlantıları</h1>
          <p>Menü öğelerini sayfalara bağlayın ve bağlantı durumunu görün.</p>
        </div>
        {isAdmin && (
          <button
            onClick={handleGuncelle}
            disabled={guncelleniyor}
            style={{
              padding: '8px 18px', background: guncelleniyor ? '#aaa' : '#1a4a7a',
              color: '#fff', border: 'none', borderRadius: 7,
              cursor: guncelleniyor ? 'not-allowed' : 'pointer',
              fontWeight: 600, fontSize: 13,
            }}>
            {guncelleniyor ? '⏳ Güncelleniyor...' : '🔄 Sayfa Listesini Güncelle'}
          </button>
        )}
      </div>

      {mesaj && (
        <div style={{ background: '#d5f5e3', color: '#1e8449', padding: '10px 14px',
          borderRadius: 4, marginBottom: 16, fontSize: 13 }}>
          {mesaj}
        </div>
      )}

      {/* Sekmeler */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 16,
        borderBottom: '2px solid #e0e0e0' }}>
        {[
          { key: 'menu',  label: '📋 Menü Bağlantıları' },
          { key: 'sayfa', label: '🔗 Sayfa Bağlantı Durumu' },
        ].map(s => (
          <button key={s.key} onClick={() => setSekme(s.key as any)}
            style={{
              padding: '10px 20px', fontSize: 13, border: 'none',
              background: 'transparent', cursor: 'pointer',
              fontWeight: sekme === s.key ? 700 : 400,
              color: sekme === s.key ? '#1a5276' : '#777',
              borderBottom: sekme === s.key ? '3px solid #1a5276' : '3px solid transparent',
              marginBottom: -2,
            }}>
            {s.label}
          </button>
        ))}
      </div>

      {sekme === 'menu'  && <MenuBaglantilari bildir={bildir} isAdmin={isAdmin} />}
      {sekme === 'sayfa' && <SayfaDurumu />}
    </div>
  );
}
